<!-- Blocked/Suspended State -->
<ng-container *ngIf="condition && isBlockedOrSuspended">
  <div class="buyer-status-container">
    <button
      [ngClass]="classStyle || 'bid-btn width-100'"
      class="blocked-suspended-btn"
      [class.blocked]="isBlocked"
      [class.suspended]="isSuspended"
      disabled
    >
      <ng-container *ngIf="isBlocked">
        <mat-icon class="status-icon">block</mat-icon>
        {{ 'buyer_status.blocked' | translate }}
      </ng-container>
      <ng-container *ngIf="isSuspended && !isBlocked">
        <mat-icon class="status-icon">pause_circle</mat-icon>
        {{ 'buyer_status.suspended' | translate }}
      </ng-container>
    </button>
    <div class="status-message" *ngIf="isBlocked && sellerEmail">
      <span>{{ 'buyer_status.contact_seller' | translate }}</span>
      <a [href]="'mailto:' + sellerEmail" class="seller-email">{{ sellerEmail }}</a>
    </div>
    <div class="status-message" *ngIf="isSuspended && !isBlocked">
      <span>{{ 'buyer_status.suspended_message_short' | translate }}</span>
    </div>
  </div>
</ng-container>

<!-- Normal Bid Now Button -->
<a
  [ngClass]="classStyle || 'bid-btn width-100'"
  *ngIf="condition && !isBlockedOrSuspended"
  (click)="bidNowClicked($event)"
  [disabled]="isDisabled"
  [attr.data-translation-key]="'horse_info_actions_bid_now'"
>
  <img src="../../../../../../assets/images/light-bid-icon.svg" alt="" />
  {{ 'horse_info.actions_bid_now' | translate }}
</a>
